export const renderBlocksAsParagraphs = (blocks: any, keyPrefix: string) => {
  if (!blocks) return null

  if (typeof blocks === 'string') {
    return <p className="qs-col-intro">{blocks}</p>
  }

  if (!Array.isArray(blocks)) {
    return <p className="qs-col-intro">{String(blocks)}</p>
  }

  const paragraphs = blocks
    .map((block: any) => {
      return (block?.children || [])
        .map((child: any) => child?.text || '')
        .join('')
        .trim()
    })
    .filter((text: string) => Boolean(text))

  return paragraphs.map((text: string, index: number) => (
    <p className="qs-col-intro" key={`${keyPrefix}-${index}`}>
      {text}
    </p>
  ))
}
